import { createSlice } from "@reduxjs/toolkit";

export const LoginSessionData = createSlice({
  name: "LoginData",
  initialState: {
    accessToken: "",
    userDto: {},
    isdCode: "+91",
    mobileNumber: "",
    userRoleId: "",
    isForgotPassword:false
  },
  reducers: {
    setAccessToken(state, action) {
      state.accessToken = action.payload;
    },
    setUserDto(state, action) {
      state.userDto = action.payload;
    },
    setIsdCode(state, action) {
      state.isdCode = action.payload;
    },
    setMobileNumber(state, action) {
      state.mobileNumber = action.payload;
    },
    setUserRoleId(state, action) {
      state.userRoleId = action.payload;
    },
    setIsForgotPassword(state,action){
      state.isForgotPassword=action.payload;
    }
  },
});

export const {
  setAccessToken,
  setMobileNumber,
  setIsdCode,
  setUserDto,
  setUserRoleId,
  setIsForgotPassword
} = LoginSessionData.actions;

export default LoginSessionData.reducer;
